(ns portal.role-ocp.db
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.permissions :as permissions]
            [common.util :as util]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def entity-name "Role")

(spec/def ::name
  (spec/and string?
            (complement str/blank?)))

(spec/def ::value
  (spec/keys :req-un [::name]))

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser string?
  [_ problem key]
  {:message "The field should be a string"
   :in (:in problem)
   :problem problem})

(def initial-value
  {:name ""
   :advertiserIds []
   :permissions {}})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :role-ocp.db ::value)))

(rf/reg-event-fx :role-ocp.db/init-form
  (fn [{:keys [db]} [_ role]]
    (let [role* (update role :permissions permissions/->internal-representation)]
      (cond-> {:db db
               :fx [[:dispatch [:role-ocp.db/init]]]}
        role (update-in [:db :role-ocp.db] assoc :value role* :initial-value role* :mode :edit)
        (not role) (assoc-in [:db :role-ocp.db :mode] :create)))))

(def forward-events [{:events #{:resource.roles/post-success
                                :resource.roles/patch-success}
                      :dispatch-to [:role-ocp.db/submit-success]}
                     {:events #{:resource.roles/delete-success}
                      :dispatch-to [:role-ocp.db/delete-success]}
                     {:events #{:resource.roles/post-failure
                                :resource.roles/patch-failure
                                :resource.roles/delete-failure}
                      :dispatch-to [:role-ocp.db/submit-failure]}])

(rf/reg-event-fx :role-ocp.db/delete-role
  (fn [{:keys [db]} _]
    (let [id (get-in db [:role-ocp.db :value :id])]
      {:dispatch-n [[:loader/open]
                    [:resource.roles/delete id]]})))

(rf/reg-event-fx :role-ocp.db/submit-form
  [(rf/inject-cofx :sub :role-ocp.db/mode)]
  (fn [{:keys [db] :as cofx} _]
    (let [mode (:role-ocp.db/mode cofx)
          payload (-> db
                      (get-in [:role-ocp.db :value])
                      (update :permissions permissions/->external-representation)
                      (select-keys [:name :permissions :advertiserIds]))
          event (if (= :create mode)
                  [:resource.roles/post payload]
                  [:resource.roles/patch
                   (get-in db [:role-ocp.db :value :id])
                   payload])]
      {:dispatch-n [[:loader/open]
                    event]})))

(rf/reg-event-fx :role-ocp.db/submit-success
  (fn [_ _]
    {:dispatch-n [[:ocp/close]
                  [:loader/close]
                  [:response-handler/handle-response
                   {:entity-name entity-name
                    :type :success}]
                  [:role-table.db/refresh]]}))

(rf/reg-event-fx :role-ocp.db/delete-success
  (fn [_ _]
    {:dispatch-n [[:ocp/close]
                  [:loader/close]
                  [:response-handler/handle-response
                   {:entity-name entity-name
                    :type :success
                    :message "Successfully deleted"}]
                  [:role-table.db/refresh]]}))

(rf/reg-event-db :role-ocp.db/on-change-permission
  (fn [db [_ path value]]
    (update-in db [:role-ocp.db :value :permissions] permissions/assoc-in-permissions (rest path) value)))

(defn get-field-errors
  [mapping error]
  (when-let [spec (get-in error [:error :spec])]
    (when-let [first-error (first spec)]
      (let [error-code-by-field (util/map-vals first first-error)]
        (into {}
              (keep (fn [[field error-code]]
                      (when-let [error-message (get-in mapping [field error-code])]
                        [field error-message]))
                    error-code-by-field))))))

(def error-mapping
  {:name {"duplicate" "Name must be unique"}})

(rf/reg-event-fx :role-ocp.db/submit-failure
  (fn [{:keys [db]} [event [_ response]]]
    (let [error-messages (get-field-errors error-mapping (:value response))
          errors (->> error-messages
                      (map (fn [[k v]]
                             [[k] [{:message v}]]))
                      (into {}))]
      {:db (update-in db [:role-ocp.db] assoc :errors errors)
       :dispatch-n [[:loader/close]
                    [:response-handler/handle-response
                     {:entity-name entity-name
                      :type :error
                      :event event
                      :response response}]]})))

(rf/reg-sub :role-ocp.db/advertiser-checkbox-disabled?
  (fn [db]
    (boolean (seq (get-in db [:role-ocp.db :value :advertiserIds])))))

(rf/reg-sub :role-ocp.db/limit-to-advertisers-disabled?
  (fn [db]
    (boolean (get-in db [:role-ocp.db :value :permissions :management :useraccounts]))))

(rf/reg-sub :role-ocp.db/users-and-roles-disabled?
  (fn [db]
    (boolean (seq (get-in db [:role-ocp.db :value :advertiserIds])))))

(rf/reg-sub :role-ocp.db/mode
  (fn [db]
    (get-in db [:role-ocp.db :mode])))

(def use-error-message (partial form/use-error-message :role-ocp.db))

(def use-bind-control (partial form/use-bind-control :role-ocp.db))

(form/register-form {:namespace :role-ocp.db
                     :initial-value initial-value
                     :validate-form validate-form
                     :forward-events forward-events
                     :submit-event :role-ocp.db/submit-form})
